import {createStore, applyMiddleware } from 'redux';
import thunk                           from 'redux-thunk';
import promise                         from 'redux-promise';
import { composeWithDevTools }         from 'redux-devtools-extension';

import rootReducer                     from '../reducers/index';

export const configStore = initialState => {
    return createStore(
        rootReducer,
        initialState,
        composeWithDevTools(applyMiddleware(thunk, promise))
    );
};


// WEBPACK FOOTER //
// ./src/store/index.js